export default "__VITE_ASSET__CfhvpawB__"